import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import PopularWorks from './components/PopularWorks';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫星球',
  url: 'http://911hl.cn/',
  description: '韩漫星球 - 最全的韩国漫画免费在线阅读平台，提供下拉式韩漫阅读体验，每日更新热门韩漫。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'http://911hl.cn/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫星球',
  url: 'http://911hl.cn/',
  description: '国内领先的韩国漫画在线免费阅读平台',
  email: 'hello@911hl.cn',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '北京',
    addressRegion: '朝阳区',
    streetAddress: '望京SOHO T3-A座 2508室',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '010-8888-6666',
    contactType: 'customer service',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '韩漫星球是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫星球是一个专注于韩国漫画在线免费阅读的平台，提供最全面的韩漫资源，支持下拉式阅读体验。收录超过3200部韩国漫画作品，每日更新，全部免费阅读。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫星球上的漫画真的免费吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，韩漫星球上所有的漫画资源完全免费阅读。我们致力于为读者提供无障碍的韩漫阅读体验，无需付费即可畅享所有作品。',
      },
    },
    {
      '@type': 'Question',
      name: '网站支持哪些设备阅读？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫星球采用响应式设计，完美适配电脑、平板和手机等各类设备。下拉式阅读方式特别针对手机端进行了优化。',
      },
    },
    {
      '@type': 'Question',
      name: '漫画多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '热门连载作品通常每周更新一次，部分热门作品可能每周更新两次。与多家韩国漫画平台合作，确保最快速度同步更新。',
      },
    },
    {
      '@type': 'Question',
      name: '如何找到我想看的漫画？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '可以通过网站顶部的搜索栏直接搜索漫画名称，也可以通过首页的分类导航浏览不同类型。还提供热门推荐和最新更新列表。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩漫星球 - 韩国漫画免费在线阅读 | 最全下拉式韩漫平台"
        description="韩漫星球提供最全面的韩国漫画免费在线阅读，涵盖热门韩漫、最新连载、经典完结作品。下拉式阅读体验，高清画质，每日更新，是您最佳的韩漫阅读平台。"
        keywords="韩国漫画,韩漫免费阅读,下拉式韩漫,最全韩漫,韩漫阅读平台,韩漫在线,韩国漫画网站"
        canonicalPath="/"
        schemaJson={[orgSchema, homeSchema, faqSchema]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <article>
            <HeroSection />
            <FeatureGrid />
            <PopularWorks />
            <TestimonialSection />
            <CTASection />
            <FAQSection />
          </article>
        </main>

        <Footer />
      </div>
    </>
  );
}